import { render, staticRenderFns } from "./DocumentVerifyList.vue?vue&type=template&id=3c779972&scoped=true"
import script from "./DocumentVerifyList.vue?vue&type=script&lang=js"
export * from "./DocumentVerifyList.vue?vue&type=script&lang=js"
import style0 from "./DocumentVerifyList.vue?vue&type=style&index=0&id=3c779972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c779972",
  null
  
)

export default component.exports